import details from './details'

export default {
  title: 'UMP 21',
  slug: 'ump-21',
  createdAt: '2020-12-21T16:52:19.814Z',
  description: '',
  details,
  tint: '#f92a70'
}
